import { EOffersByRealtyOfferIdActionTypes } from '../../actions/offersByRealtyOfferId';
import {
  EGetOffersByRealtyOfferIdStatus,
  EOfferNoteStatus,
  IOffersByRealtyOfferIdState,
} from '../../types/offersByRealtyOfferId';
import { TReduxActions } from '../../types/redux';

export const defaultState: IOffersByRealtyOfferIdState = {
  folderOffers: [],
  status: EGetOffersByRealtyOfferIdStatus.Initial,
  noteStatus: EOfferNoteStatus.Initial,
};

export const offersByRealtyOfferIdReducer = (
  state: IOffersByRealtyOfferIdState = defaultState,
  action: TReduxActions,
) => {
  switch (action.type) {
    case EOffersByRealtyOfferIdActionTypes.Set:
      return {
        ...state,
        folderOffers: action.payload.folderOffers,
        status: EGetOffersByRealtyOfferIdStatus.Succeed,
      };

    case EOffersByRealtyOfferIdActionTypes.SetLoading:
      return {
        ...state,
        status: EGetOffersByRealtyOfferIdStatus.Loading,
      };

    case EOffersByRealtyOfferIdActionTypes.SetFailed:
      return {
        ...state,
        status: EGetOffersByRealtyOfferIdStatus.Failed,
        folderOffers: [],
      };

    case EOffersByRealtyOfferIdActionTypes.SetNote:
      return {
        ...state,
        folderOffers: state.folderOffers.map(offer => {
          return offer.entityId === action.payload.realtyOfferId ? { ...offer, note: action.payload.comment } : offer;
        }),
        noteStatus: EOfferNoteStatus.Succeed,
      };

    case EOffersByRealtyOfferIdActionTypes.SetNoteLoading:
      return {
        ...state,
        noteStatus: EOfferNoteStatus.Loading,
      };

    case EOffersByRealtyOfferIdActionTypes.SetNoteFailed:
      return {
        ...state,
        noteStatus: EOfferNoteStatus.Failed,
      };

    default:
      return state;
  }
};
